export default __webpack_public_path__ + "static/media/swapCard.1a0376fd.png";